// src/components/analytics/KpiBoard.tsx
import React from "react";
import { Grid } from "@mui/material";
import KpiCard from "./KPICard";
import numeral from "numeral";
import "numeral/locales/de";
import { TopLevelPaper } from "../../../../../../../themes/StyledComponents";
import { KpiAnalyticsDto } from "../../../../../../../api-client";

interface Props {
  data: KpiAnalyticsDto;
}

numeral.locale("de");
const euro = (n: number): string => {
  return numeral(n).format("0,0.00 $");
};

const KpiBoard: React.FC<Props> = ({ data }) => {
  const {
    totalBills,
    totalAmount,
    totalRxs,
    uniquePayersCount,
    billsGrowthPercentage,
    amountGrowthPercentage,
    rxsGrowthPercentage,
    payersGrowthPercentage,
  } = data;

  return (
    <TopLevelPaper
      elevation={2}
      sx={{
        p: 2,
        mb: 1,
        border: "0px",
      }}
    >
      <Grid container spacing={1}>
        <Grid item md={3}>
          <KpiCard
            label="Rechnungen"
            value={totalBills}
            delta={billsGrowthPercentage}
          />
        </Grid>
        <Grid item md={3}>
          <KpiCard
            label="Rezepte"
            value={totalRxs}
            delta={rxsGrowthPercentage}
          />
        </Grid>
        <Grid item md={3}>
          <KpiCard
            label="Kostenträger"
            value={uniquePayersCount}
            delta={payersGrowthPercentage}
          />
        </Grid>
        <Grid item md={3}>
          <KpiCard
            label="Gesamt (€)"
            value={euro(totalAmount)}
            delta={amountGrowthPercentage}
          />
        </Grid>

        {/* row 2 */}
      </Grid>
    </TopLevelPaper>
  );
};

export default KpiBoard;
